import { BaseModel } from "@blue-chip/core";
import ProjectReportCategory from "./ProjectReportCategory";

export default class ProjectReport extends BaseModel {
  static get belongsTo() {
    return [ProjectReportCategory];
  }
}
